// import React, { useEffect, useState } from "react";
// import { Modal, Button, Form, Table } from "react-bootstrap";
// import { FaEdit } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// function ProductRateList() {
//   const [productRate, setProductRate] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [showMessageModal, setShowMessageModal] = useState(false);
//   const [messageModalContent, setMessageModalContent] = useState({
//     title: "",
//     text: "",
//     type: "",
//     confirmAction: null,
//   });

//   const [showEditModal, setShowEditModal] = useState(false);
//   const [currentRate, setCurrentRate] = useState(null);

//   const showCustomMessageModal = (title, text, type, confirmAction = null) => {
//     setMessageModalContent({ title, text, type, confirmAction });
//     setShowMessageModal(true);
//   };

//   const closeCustomMessageModal = () => {
//     setShowMessageModal(false);
//     setMessageModalContent({
//       title: "",
//       text: "",
//       type: "",
//       confirmAction: null,
//     });
//   };

//   const getAuthToken = () => localStorage.getItem("token");

//   const fetchProductRates = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Authentication token not found. Please log in.",
//           "error",
//         );
//         setLoading(false);
//         return;
//       }

//       const url = `${API_URL}/product-loan-rate-list`;

//       const response = await fetch(url, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           showCustomMessageModal(
//             "Authorization Error",
//             "Unauthorized: Please log in again.",
//             "error",
//           );
//         }
//         const errorData = await response.json();
//         throw new Error(
//           errorData.message || "Failed to fetch Product Income List.",
//         );
//       }

//       const data = await response.json();
//       setProductRate(data.data || []);
//     } catch (err) {
//       console.error("Fetch Product Income List error:", err);
//       setError(err.message);
//       if (!showMessageModal) {
//         showCustomMessageModal(
//           "Error",
//           err.message ||
//             "An unexpected error occurred while fetching Product Income List.",
//           "error",
//         );
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEditClick = (rate) => {
//     setCurrentRate(rate);
//     setShowEditModal(true);
//   };

//   const updateProductRate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomMessageModal(
//           "Authentication Error",
//           "Please log in.",
//           "error",
//         );
//         setLoading(false);
//         return;
//       }

//       const url = `${API_URL}/product-loan-rate-update`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(currentRate),
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.message || "Failed to update rate.");
//       }

//       await fetchProductRates();
//       setShowEditModal(false);
//       showCustomMessageModal(
//         "Success",
//         "Product Rate updated successfully.",
//         "success",
//       );
//     } catch (err) {
//       console.error("Update error:", err);
//       showCustomMessageModal(
//         "Error",
//         err.message || "An unexpected error occurred during update.",
//         "error",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const closeEditModal = () => {
//     setShowEditModal(false);
//     setCurrentRate(null);
//   };

//   useEffect(() => {
//     fetchProductRates();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ---------------- LOADING ----------------
//   if (loading) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <div className="spinner-border text-primary" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   // ---------------- ERROR ----------------
//   if (error) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <div className="alert alert-danger text-center" role="alert">
//           {error}
//           <button
//             className="btn btn-primary ms-3"
//             onClick={() => fetchProductRates()}
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // ---------------- MAIN ----------------
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               📦
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Product Loan Income List
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Manage product loan rate slabs and income targets
//               </p>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               <div className="table-responsive">
//                 <Table bordered>
//                   <thead
//                     style={{
//                       background:
//                         "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                     }}
//                   >
//                     <tr>
//                       <th>ID</th>
//                       <th>From-To</th>
//                       <th>Direct Income</th>
//                       <th>Differential Income after achieve target</th>
//                       <th>Level</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {productRate?.length > 0 ? (
//                       productRate.map((productrate, i) => (
//                         <tr key={productrate.id}>
//                           <td>{i + 1}</td>
//                           <td>
//                             {productrate.from_target} -{" "}
//                             {productrate.to_target}
//                           </td>
//                           <td>{productrate.direct_income}</td>
//                           <td>
//                             {
//                               productrate.differential_Income_after_achieve_target
//                             }
//                           </td>
//                           <td>{productrate.lavel}</td>
//                           <td>
//                             <Button
//                               onClick={() => handleEditClick(productrate)}
//                               className="page-link"
//                             >
//                               <FaEdit />
//                             </Button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="6" className="text-center">
//                           No Product Loan Income found.
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 MESSAGE MODAL */}
//       <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
//         <Modal.Header
//           closeButton
//           className={`border-top border-4 ${
//             messageModalContent.type === "success"
//               ? "border-success"
//               : messageModalContent.type === "error"
//                 ? "border-danger"
//                 : "border-warning"
//           }`}
//         >
//           <Modal.Title
//             className={`modal-title ${
//               messageModalContent.type === "success"
//                 ? "text-success"
//                 : messageModalContent.type === "error"
//                   ? "text-danger"
//                   : "text-warning"
//             }`}
//           >
//             {messageModalContent.title}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-secondary">
//           <p>{messageModalContent.text}</p>
//         </Modal.Body>
//         <Modal.Footer className="justify-content-center">
//           {messageModalContent.type === "confirmation" ? (
//             <>
//               <Button variant="secondary" onClick={closeCustomMessageModal}>
//                 Cancel
//               </Button>
//               <Button
//                 variant="primary"
//                 onClick={() => {
//                   if (messageModalContent.confirmAction)
//                     messageModalContent.confirmAction();
//                   closeCustomMessageModal();
//                 }}
//               >
//                 Confirm
//               </Button>
//             </>
//           ) : (
//             <Button
//               variant={
//                 messageModalContent.type === "success"
//                   ? "success"
//                   : messageModalContent.type === "error"
//                     ? "danger"
//                     : "primary"
//               }
//               onClick={closeCustomMessageModal}
//             >
//               OK
//             </Button>
//           )}
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 EDIT MODAL — Premium 2-column layout */}
//       <Modal show={showEditModal} onHide={closeEditModal} centered size="lg">
//         <Modal.Header
//           closeButton
//           style={{
//             background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//             color: "#ffffff",
//             borderTopLeftRadius: "12px",
//             borderTopRightRadius: "12px",
//             borderBottom: "none",
//             padding: "18px 24px",
//           }}
//         >
//           <Modal.Title
//             style={{
//               fontSize: "18px",
//               fontWeight: "700",
//               letterSpacing: "0.3px",
//               color: "#ffffff",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//             }}
//           >
//             ✏️ Edit Product Loan Rate
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body style={{ padding: "24px 28px", background: "#ffffff" }}>
//           {currentRate && (
//             <Form onSubmit={updateProductRate}>
//               <div className="row">
//                 {/* From Target */}
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label
//                       style={{ fontWeight: "600", color: "#1e3a5f" }}
//                     >
//                       From Target
//                     </Form.Label>
//                     <Form.Control
//                       type="number"
//                       value={currentRate.from_target}
//                       onChange={(e) =>
//                         setCurrentRate({
//                           ...currentRate,
//                           from_target: e.target.value,
//                         })
//                       }
//                       style={{
//                         borderRadius: "10px",
//                         padding: "10px 14px",
//                         border: "1.5px solid #e2e8f0",
//                       }}
//                       required
//                     />
//                   </Form.Group>
//                 </div>

//                 {/* To Target */}
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label
//                       style={{ fontWeight: "600", color: "#1e3a5f" }}
//                     >
//                       To Target
//                     </Form.Label>
//                     <Form.Control
//                       type="text"
//                       value={currentRate.to_target}
//                       onChange={(e) =>
//                         setCurrentRate({
//                           ...currentRate,
//                           to_target: e.target.value,
//                         })
//                       }
//                       style={{
//                         borderRadius: "10px",
//                         padding: "10px 14px",
//                         border: "1.5px solid #e2e8f0",
//                       }}
//                       required
//                     />
//                   </Form.Group>
//                 </div>

//                 {/* Direct Income */}
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label
//                       style={{ fontWeight: "600", color: "#1e3a5f" }}
//                     >
//                       Direct Income
//                     </Form.Label>
//                     <Form.Control
//                       type="number"
//                       value={currentRate.direct_income}
//                       onChange={(e) =>
//                         setCurrentRate({
//                           ...currentRate,
//                           direct_income: e.target.value,
//                         })
//                       }
//                       style={{
//                         borderRadius: "10px",
//                         padding: "10px 14px",
//                         border: "1.5px solid #e2e8f0",
//                       }}
//                       required
//                     />
//                   </Form.Group>
//                 </div>

//                 {/* Differential Income */}
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label
//                       style={{ fontWeight: "600", color: "#1e3a5f" }}
//                     >
//                       Differential Income after achieve target
//                     </Form.Label>
//                     <Form.Control
//                       type="number"
//                       value={
//                         currentRate.differential_Income_after_achieve_target
//                       }
//                       onChange={(e) =>
//                         setCurrentRate({
//                           ...currentRate,
//                           differential_Income_after_achieve_target:
//                             e.target.value,
//                         })
//                       }
//                       style={{
//                         borderRadius: "10px",
//                         padding: "10px 14px",
//                         border: "1.5px solid #e2e8f0",
//                       }}
//                       required
//                     />
//                   </Form.Group>
//                 </div>

//                 {/* Level */}
//                 <div className="col-md-6">
//                   <Form.Group className="mb-3">
//                     <Form.Label
//                       style={{ fontWeight: "600", color: "#1e3a5f" }}
//                     >
//                       Level
//                     </Form.Label>
//                     <Form.Control
//                       type="number"
//                       value={currentRate.lavel}
//                       onChange={(e) =>
//                         setCurrentRate({
//                           ...currentRate,
//                           lavel: e.target.value,
//                         })
//                       }
//                       style={{
//                         borderRadius: "10px",
//                         padding: "10px 14px",
//                         border: "1.5px solid #e2e8f0",
//                       }}
//                       required
//                     />
//                   </Form.Group>
//                 </div>
//               </div>

//               {/* Buttons */}
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "flex-end",
//                   gap: "10px",
//                   paddingTop: "16px",
//                   borderTop: "1.5px dashed #e2e8f0",
//                   marginTop: "10px",
//                 }}
//               >
//                 <button
//                   type="button"
//                   onClick={closeEditModal}
//                   style={{
//                     padding: "10px 24px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #cbd5e1",
//                     background: "#ffffff",
//                     color: "#475569",
//                     fontSize: "14px",
//                     fontWeight: "700",
//                     cursor: "pointer",
//                     transition: "all 0.25s ease",
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   style={{
//                     padding: "10px 28px",
//                     borderRadius: "10px",
//                     border: "none",
//                     background:
//                       "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                     color: "#ffffff",
//                     fontSize: "14px",
//                     fontWeight: "800",
//                     letterSpacing: "0.4px",
//                     cursor: "pointer",
//                     transition: "all 0.25s ease",
//                     boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                   }}
//                 >
//                   Update
//                 </button>
//               </div>
//             </Form>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }

// export default ProductRateList;

import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL;
const ITEMS_PER_PAGE = 10;

function ProductRateList() {
  const [productRate, setProductRate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageModalContent, setMessageModalContent] = useState({
    title: "",
    text: "",
    type: "",
    confirmAction: null,
  });

  const [showEditModal, setShowEditModal] = useState(false);
  const [currentRate, setCurrentRate] = useState(null);

  // ✅ Pagination state
  const [currentPage, setCurrentPage] = useState(1);

  const showCustomMessageModal = (title, text, type, confirmAction = null) => {
    setMessageModalContent({ title, text, type, confirmAction });
    setShowMessageModal(true);
  };

  const closeCustomMessageModal = () => {
    setShowMessageModal(false);
    setMessageModalContent({
      title: "",
      text: "",
      type: "",
      confirmAction: null,
    });
  };

  const getAuthToken = () => localStorage.getItem("token");

  const fetchProductRates = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Authentication token not found. Please log in.",
          "error"
        );
        setLoading(false);
        return;
      }

      const url = `${API_URL}/product-loan-rate-list`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          showCustomMessageModal(
            "Authorization Error",
            "Unauthorized: Please log in again.",
            "error"
          );
        }
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Failed to fetch Product Income List."
        );
      }

      const data = await response.json();
      setProductRate(data.data || []);
      setCurrentPage(1); // ✅ Reset on fresh fetch
    } catch (err) {
      console.error("Fetch Product Income List error:", err);
      setError(err.message);
      if (!showMessageModal) {
        showCustomMessageModal(
          "Error",
          err.message ||
            "An unexpected error occurred while fetching Product Income List.",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (rate) => {
    setCurrentRate(rate);
    setShowEditModal(true);
  };

  const updateProductRate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        showCustomMessageModal(
          "Authentication Error",
          "Please log in.",
          "error"
        );
        setLoading(false);
        return;
      }

      const url = `${API_URL}/product-loan-rate-update`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(currentRate),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to update rate.");
      }

      await fetchProductRates();
      setShowEditModal(false);
      showCustomMessageModal(
        "Success",
        "Product Rate updated successfully.",
        "success"
      );
    } catch (err) {
      console.error("Update error:", err);
      showCustomMessageModal(
        "Error",
        err.message || "An unexpected error occurred during update.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setCurrentRate(null);
  };

  useEffect(() => {
    fetchProductRates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ✅ Pagination logic */
  const totalPages = Math.ceil(productRate.length / ITEMS_PER_PAGE) || 1;
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const currentPageData = productRate.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // ---------------- LOADING ----------------
  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // ---------------- ERROR ----------------
  if (error) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="alert alert-danger text-center" role="alert">
          {error}
          <button
            className="btn btn-primary ms-3"
            onClick={() => fetchProductRates()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // ---------------- MAIN ----------------
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📦
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Product Loan Income List
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Manage product loan rate slabs and income targets
              </p>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "30px" }}>
              {/* ✅ Scrollable container with sticky header */}
              <div
                className="table-responsive"
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  position: "relative",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <Table bordered style={{ marginBottom: 0 }}>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 5,
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    <tr>
                      {[
                        "ID",
                        "From-To",
                        "Direct Income",
                        "Differential Income after achieve target",
                        "Level",
                        "Actions",
                      ].map((heading, i) => (
                        <th
                          key={i}
                          style={{
                            position: "sticky",
                            top: 0,
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            color: "#ffffff",
                            zIndex: 6,
                            whiteSpace: "nowrap",
                            padding: "12px 10px",
                            borderColor: "#2b6cb0",
                          }}
                        >
                          {heading}
                        </th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {currentPageData?.length > 0 ? (
                      currentPageData.map((productrate, i) => (
                        <tr key={productrate.id}>
                          <td>{startIndex + i + 1}</td>
                          <td>
                            {productrate.from_target} -{" "}
                            {productrate.to_target}
                          </td>
                          <td>{productrate.direct_income}</td>
                          <td>
                            {
                              productrate.differential_Income_after_achieve_target
                            }
                          </td>
                          <td>{productrate.lavel}</td>
                          <td>
                            <Button
                              onClick={() => handleEditClick(productrate)}
                              className="page-link"
                            >
                              <FaEdit />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No Product Loan Income found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* ✅ Custom pill pagination */}
              {productRate.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "24px",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {/* Prev */}
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        padding: "9px 18px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                        fontSize: "13.5px",
                        fontWeight: "700",
                        cursor:
                          currentPage === 1 ? "not-allowed" : "pointer",
                        transition: "all 0.2s ease",
                        letterSpacing: "0.3px",
                      }}
                      onMouseEnter={(e) => {
                        if (currentPage !== 1) {
                          e.currentTarget.style.background = "#f0f6ff";
                          e.currentTarget.style.borderColor = "#1e5799";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#ffffff";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      ‹ Prev
                    </button>

                    {/* Page Numbers */}
                    {Array.from(
                      { length: totalPages },
                      (_, i) => i + 1
                    ).map((pageNum) => {
                      const isActive = pageNum === currentPage;
                      return (
                        <button
                          key={pageNum}
                          onClick={() => handlePageChange(pageNum)}
                          style={{
                            minWidth: "42px",
                            height: "42px",
                            padding: "0 12px",
                            borderRadius: "10px",
                            border: isActive
                              ? "none"
                              : "1.5px solid #e2e8f0",
                            background: isActive
                              ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                              : "#ffffff",
                            color: isActive ? "#ffffff" : "#1e5799",
                            fontSize: "14px",
                            fontWeight: "700",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            boxShadow: isActive
                              ? "0 6px 14px rgba(30, 87, 153, 0.3)"
                              : "none",
                          }}
                          onMouseEnter={(e) => {
                            if (!isActive) {
                              e.currentTarget.style.background = "#f0f6ff";
                              e.currentTarget.style.borderColor = "#1e5799";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isActive) {
                              e.currentTarget.style.background = "#ffffff";
                              e.currentTarget.style.borderColor = "#e2e8f0";
                            }
                          }}
                        >
                          {pageNum}
                        </button>
                      );
                    })}

                    {/* Next */}
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "9px 18px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          currentPage === totalPages
                            ? "#cbd5e1"
                            : "#1e5799",
                        fontSize: "13.5px",
                        fontWeight: "700",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        transition: "all 0.2s ease",
                        letterSpacing: "0.3px",
                      }}
                      onMouseEnter={(e) => {
                        if (currentPage !== totalPages) {
                          e.currentTarget.style.background = "#f0f6ff";
                          e.currentTarget.style.borderColor = "#1e5799";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "#ffffff";
                        e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      Next ›
                    </button>
                  </div>

                  {/* Page info text */}
                 
                </div>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* 🎯 MESSAGE MODAL */}
      <Modal show={showMessageModal} onHide={closeCustomMessageModal} centered>
        <Modal.Header
          closeButton
          className={`border-top border-4 ${
            messageModalContent.type === "success"
              ? "border-success"
              : messageModalContent.type === "error"
              ? "border-danger"
              : "border-warning"
          }`}
        >
          <Modal.Title
            className={`modal-title ${
              messageModalContent.type === "success"
                ? "text-success"
                : messageModalContent.type === "error"
                ? "text-danger"
                : "text-warning"
            }`}
          >
            {messageModalContent.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-secondary">
          <p>{messageModalContent.text}</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          {messageModalContent.type === "confirmation" ? (
            <>
              <Button variant="secondary" onClick={closeCustomMessageModal}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  if (messageModalContent.confirmAction)
                    messageModalContent.confirmAction();
                  closeCustomMessageModal();
                }}
              >
                Confirm
              </Button>
            </>
          ) : (
            <Button
              variant={
                messageModalContent.type === "success"
                  ? "success"
                  : messageModalContent.type === "error"
                  ? "danger"
                  : "primary"
              }
              onClick={closeCustomMessageModal}
            >
              OK
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* 🎯 EDIT MODAL */}
      <Modal show={showEditModal} onHide={closeEditModal} centered size="lg">
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
            color: "#ffffff",
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            borderBottom: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title
            style={{
              fontSize: "18px",
              fontWeight: "700",
              letterSpacing: "0.3px",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            ✏️ Edit Product Loan Rate
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "24px 28px", background: "#ffffff" }}>
          {currentRate && (
            <Form onSubmit={updateProductRate}>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ fontWeight: "600", color: "#1e3a5f" }}
                    >
                      From Target
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={currentRate.from_target}
                      onChange={(e) =>
                        setCurrentRate({
                          ...currentRate,
                          from_target: e.target.value,
                        })
                      }
                      style={{
                        borderRadius: "10px",
                        padding: "10px 14px",
                        border: "1.5px solid #e2e8f0",
                      }}
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ fontWeight: "600", color: "#1e3a5f" }}
                    >
                      To Target
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={currentRate.to_target}
                      onChange={(e) =>
                        setCurrentRate({
                          ...currentRate,
                          to_target: e.target.value,
                        })
                      }
                      style={{
                        borderRadius: "10px",
                        padding: "10px 14px",
                        border: "1.5px solid #e2e8f0",
                      }}
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ fontWeight: "600", color: "#1e3a5f" }}
                    >
                      Direct Income
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={currentRate.direct_income}
                      onChange={(e) =>
                        setCurrentRate({
                          ...currentRate,
                          direct_income: e.target.value,
                        })
                      }
                      style={{
                        borderRadius: "10px",
                        padding: "10px 14px",
                        border: "1.5px solid #e2e8f0",
                      }}
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ fontWeight: "600", color: "#1e3a5f" }}
                    >
                      Differential Income after achieve target
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={
                        currentRate.differential_Income_after_achieve_target
                      }
                      onChange={(e) =>
                        setCurrentRate({
                          ...currentRate,
                          differential_Income_after_achieve_target:
                            e.target.value,
                        })
                      }
                      style={{
                        borderRadius: "10px",
                        padding: "10px 14px",
                        border: "1.5px solid #e2e8f0",
                      }}
                      required
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label
                      style={{ fontWeight: "600", color: "#1e3a5f" }}
                    >
                      Level
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={currentRate.lavel}
                      onChange={(e) =>
                        setCurrentRate({
                          ...currentRate,
                          lavel: e.target.value,
                        })
                      }
                      style={{
                        borderRadius: "10px",
                        padding: "10px 14px",
                        border: "1.5px solid #e2e8f0",
                      }}
                      required
                    />
                  </Form.Group>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  paddingTop: "16px",
                  borderTop: "1.5px dashed #e2e8f0",
                  marginTop: "10px",
                }}
              >
                <button
                  type="button"
                  onClick={closeEditModal}
                  style={{
                    padding: "10px 24px",
                    borderRadius: "10px",
                    border: "1.5px solid #cbd5e1",
                    background: "#ffffff",
                    color: "#475569",
                    fontSize: "14px",
                    fontWeight: "700",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  style={{
                    padding: "10px 28px",
                    borderRadius: "10px",
                    border: "none",
                    background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: "800",
                    letterSpacing: "0.4px",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  }}
                >
                  Update
                </button>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ProductRateList;